<template>
    <div class="container_full_width " >
        <div class="container">
            <CommonBreadcrumb class="my-3"/>
        </div>
        <div class="banner">
            <picture>
                <source media="(min-width: 768px)" width="3840" height="1100" type="image/webp" srcset="~/assets/ethical-conflict/banner.webp">
                <source media="(min-width: 768px)" width="3840" height="1100" type="image/jpeg" srcset="~/assets/ethical-conflict/banner.jpg">

                <source media="(max-width: 991x)" width="750" height="400" type="image/webp" srcset="~/assets/ethical-conflict/banner_mob.webp">
                <source media="(max-width: 991px)" width="750" height="400" type="image/jpeg" srcset="~/assets/ethical-conflict/banner_mob.jpg">
                <img width="3840" height="1100" type="image/jpeg" src="~/assets/ethical-conflict/banner.jpg" alt="conflict free diamonds, ethical diamonds">
            </picture>

            <div class="banner_title">

                <h1 class="font-active ">The ‘Friendly’ <span>Diamond</span></h1>

                <p class="mb-0">FOR A FRIENDLIER <span>SPARKLE</span></p>
            </div>
        </div>

        <div class="container ethics">
            
            <div class="text-center small_title">
                <p>Don’t worry! We ain’t into the cliche talk of having the best diamonds in the industry or about being a leading retailer of the same yet again. 
                    Though that stands true, we’re just talking science here - and how the diamonds we sell are actually <i>friendly.</i></p>
            </div>

            <div class="row ethical_block text-center">
                <div class="col-12 col-md-4">
                    <div class="img_box mb-3 img_box_mod radious_eight">
                        <picture>
                            <source width="1560" height="1120" type="image/webp" srcset="~/assets/ethical-conflict/friendlycommunity.webp">
                           
                            <img width="1560" height="1120" type="image/jpeg" src="~/assets/ethical-conflict/friendlycommunity.jpg" alt="Friendly Community">
                        </picture>
                    </div>
                    <div class="text_box">
                        <h4 class="font-active">Friendly To The <span>Community</span></h4>
                        <p>Our lab grown diamonds support local communities by eliminating the need for harmful mining practices. 
                            This reduces social conflicts and ensures that substantial resources are used to benefit local economies.</p>
                    </div>
                </div>
                <div class="col-12 col-md-4  ">
                    <div class="img_box mb-3 img_box_mod radious_eight">
                        <picture>
                            <source width="1560" height="1120" type="image/webp" srcset="~/assets/ethical-conflict/friendlypeople.webp">
                          
                            <img width="1560" height="1120" type="image/jpeg" src="~/assets/ethical-conflict/friendlypeople.jpg" alt="Friendly people">
                        </picture>
                    </div>
                    <div class="text_box">
                        <h4 class="font-active">Friendly To The <span>People</span></h4>
                        <p>At Friendly Diamonds, our main priority is you. 
                            We offer ethical and budget-friendly choices for you! Our diamonds provide the same stunning quality but at a more affordable price, making luxury accessible to everyone.</p>
                    </div>
                </div> 
                <div class="col-12 col-md-4  ">
                    <div class="img_box mb-3 img_box_mod radious_eight">
                        <picture>
                            <source width="1560" height="1120" type="image/webp" srcset="~/assets/ethical-conflict/friendlyenvironment.webp">
                           
                            <img width="1560" height="1120" type="image/jpeg" src="~/assets/ethical-conflict/friendlyenvironment.jpg" alt="Friendly Environment">
                        </picture>
                    </div>
                    <div class="text_box">
                        <h4 class="font-active">Friendly To The <span>Environment</span></h4>
                        <p>
                            Having a significantly lower environmental impact and being Earth-kind is our top-most priority. 
                            All our diamonds require less energy and water, produce fewer carbon emissions, and avoid the ecological damage caused by mining.
                        </p>
                    </div>
                </div>
            </div>

            <div class="row ethical_block align-items-center">
                <div class="col-12 col-md-6  ">
                    <div class="img_box mb-3">
                        <picture>
                            <source width="1231" height="840" type="image/webp" srcset="~/assets/ethical-conflict/diamonds.webp">
                           
                            <img width="1231" height="840" class="radious_eight" type="image/jpeg" src="~/assets/ethical-conflict/diamonds.jpg" alt="diamonds">
                        </picture>
                    </div>
                </div>
                <div class="col-12 col-md-6  conflict_box">
                    <div class="text_mod mt-1">
                        <h4 class="font-active">Conflict-Free Diamonds</h4>
                        <p>Lab grown diamonds are no different to mined diamonds, except for their source. 
                            Like ice, which can be formed naturally or in your refrigerator- the composition remains identical, the output better!</p>
                    </div>    
                    <div class="text_mod mb-3 mt-3 text_display">
                        <h4 class="font-active">Are Lab Diamonds Real?</h4>
                        <p class="mb-2">Absolutely! Lab-grown diamonds possess the same physical, chemical, and optical properties as mined diamonds and the only difference lies in their origin. While natural diamonds are extracted from the Earth through mining processes, lab grown diamonds are created in controlled laboratory environments. 
                            This ensures a more ethical, environmentally-friendly approach without compromising on the quality of the beauty of the diamond.</p>
                             <div class="text_mod">
                      
                    </div>
                    </div>
                   
                </div>
                <div class="col-12 text-center text_display_mod">
                    <div class="text_mod mb-3 mt-3">
                        <h4 class="font-active">Are Lab Diamonds Real?</h4>
                        <p class="mb-0">Absolutely! Lab-grown diamonds possess the same physical, chemical, and optical properties as mined diamonds and the only difference lies in their origin. While natural diamonds are extracted from the Earth through mining processes, lab grown diamonds are created in controlled laboratory environments. 
                            This ensures a more ethical, environmentally-friendly approach without compromising on the quality of the beauty of the diamond.</p>
                    </div>
                    <div class="text_mod">
                        <p>Here is a table representing the similarities and differences between a lab-grown diamond and a natural diamond.</p>
                    </div>
                </div>
            </div>

            <div class="ethical_block">
                <p class="">Here is a table representing the similarities and differences between a lab-grown diamond and a natural diamond:</p>
                    <div class="table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th>Characteristic</th>
                                    <th>Lab Grown Diamond</th>
                                    <th>Natural Diamond</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Formation</td>
                                    <td>Created under controlled laboratory environments and conditions using High Pressure High Temperature (HPHT) or Chemical Vapour Deposition (CVD) procedures.</td>
                                    <td>Formed naturally under high pressure and high temperature over billions of years in Earth’s crust and mined.</td>
                                </tr>
                                <tr>
                                    <td>Cost</td>
                                    <td>$$ <br>
                                        Significantly cheaper than a natural diamond</td>
                                    <td>$$$$$ <br>
                                        More expensive due to the mining procedures</td>
                                </tr>
                                <tr>
                                    <td>Chemical Composition</td>
                                    <td>Carbon</td>
                                    <td>Carbon</td>
                                </tr>
                                <tr>
                                    <td>Time Taken to Grow</td>
                                    <td>30-40 days</td>
                                    <td>Millions of years</td>
                                </tr>
                                <tr>
                                    <td>Conflict Free?</td>
                                    <td>Yes</td>
                                    <td>No</td>
                                </tr>
                                <tr>
                                    <td>Hardness (Mohs)</td>
                                    <td>10</td>
                                    <td>10</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="table_info">
                        <h4 class="font-active">The Lab Diamond Growing Process</h4>
                        <p>Creating a lab grown diamond is a marvel of modern science. Lab grown diamonds are created using either High Pressure High Temperature (HPHT) or Chemical Vapor Deposition (CVD) processes, replicating the natural diamond-growing conditions within a controlled environment. Over several weeks, carbon atoms bond to this seed, 
                            forming a rough diamond that is later cut and polished to perfection. This method ensures each diamond is crafted with precision, resulting in stunning, high-quality diamonds.</p>
                    </div>
              
            </div>

     
            <div class="row ethical_block zoom">
                <div class="col-12 text-center">
   
                    <div class="row flip align-items-center mb-3" ref="imageBlocks">
                        <div class="col-12 col-md-6  ">
                            <div class="text_alt mt-3">
                                <h4 class="font-active">Ethical & Conflict-Free Origin</h4>
        
                                <p >Lab grown diamonds represent a commitment to a more kind, ethical, and carbon-neutral future. Traditional diamond mining can have devastating environmental and social impacts, including habitat destruction, soil erosion, increased water usage, human rights issues, and more. In contrast, lab grown diamonds 
                                    are produced with a minimal ecological footprint and are 100% conflict-free. By choosing us, you are supporting a friendlier transformation—one where luxury and responsibility go hand in hand.</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6  ">
                            <div class="img_alt radious_eight">
                                <picture>
                                    <source width="1230" height="660" type="image/webp" srcset="~/assets/ethical-conflict/conflictfree.webp">
                                    
                                    <img width="1230" class="radious_eight" height="660" type="image/jpeg" src="~/assets/ethical-conflict/conflictfree.jpg" alt="Conflict-Free">
                                </picture>
                            </div>
                        </div>
                    </div>


                    <div class="row align-items-center mb-3" ref="imageBlocks">
                        <div class="col-12 col-md-6  ">
                            <div class="img_alt">
                                <picture>
                                    <source width="1230" height="1200" type="image/webp" srcset="~/assets/ethical-conflict/carbonneutral.webp">
                                    <img width="1230" class="radious_eight" height="1200" type="image/jpeg" src="~/assets/ethical-conflict/carbonneutral.jpg" alt="Carbon Neutral">
                                </picture>
                            </div>
                        </div>
                        <div class="col-12 col-md-6  ">
                            <div class="text_alt mt-3">
                                <h4 class="font-active">Deemed To Be Carbon Neutral</h4>
        
                                <p>Our passion for elevating to a more transparent, sustainable, benevolent, and all-inclusive {{ $t('jewelry') }} industry is parallel to none. At Friendly Diamonds, we are dedicated to achieving carbon neutrality, recognizing the urgency of addressing climate change. We are actively trying to source our lab grown diamonds from facilities that are powered by renewable energy. By meticulously monitoring our carbon footprint and advocating for sustainable practices, we strive to lead by example and inspire others to join us in fostering a friendlier horizon.</p>
                            </div>
                        </div>
 
                    </div>

                    <div class="row flip align-items-center mb-3" ref="imageBlocks">
                        <div class="col-12 col-md-6  ">
                            <div class="text_alt mt-3">
                                <h4 class="font-active">Our Earth-Kind Promise</h4>
        
                                <p class="mb-0">At Friendly Diamonds, our journey towards a sustainable future is driven by our dedication towards a positive change. We invite you to explore our collections of ethically-sourced, unique, and exquisite {{ $t('jewelry') }}. Together, let’s advocate not just for beauty, but for the betterment of our planet and a friendlier tomorrow.</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6  ">
                            <div class="img_alt">
                                <picture>
                                    <source width="1230" height="660" type="image/webp" srcset="~/assets/ethical-conflict/promise.webp">
                                   
                                    <img width="1230" class="radious_eight" height="660" type="image/jpeg" src="~/assets/ethical-conflict/promise.jpg" alt="Friendly Promise">
                                </picture>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="row ethical_block">
                <div class="col-12">
                    <div class="end_button radious_eight">
                        <span>Our Diamonds Are <s>The Best</s> Truly Friendly!</span>
                    </div>
                </div>
            </div>
        </div>
     
    </div>
</template>

<script setup>
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );
    // const localePath = useLocalePath();

    const imageBlocks = ref([]);
    let observer = null; 

    function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
            const target = entry.target;
            if (entry.isIntersecting) {
            
                target.classList.add('zoom-active');
                target.classList.remove('zoom-reset');
                
          
                observer.unobserve(target);
            } else {
      
                target.classList.add('zoom-reset');
                target.classList.remove('zoom-active');
            }
        });
    }

    onMounted(() => {
        imageBlocks.value = document.querySelectorAll('.flip, .zoom');
        observer = new IntersectionObserver(handleIntersect, {
            threshold: 0.1,
        });

        imageBlocks.value.forEach((block) => {
            observer.observe(block);
        });
    });

    // onBeforeUnmount(() => {
    //     if (observer && imageBlocks.value) {
    //         imageBlocks.value.forEach((block) => {
    //             observer.unobserve(block);
    //         });
    //         observer.disconnect();
    //     }
    // });
</script>

<style scoped>
/* Common */
.ethical_block {
    margin: 60px 0;
}

h4 {
    font-size: 24px;
    color: #353535;
    margin-bottom: 8px;
}

p {
    font-size: 16px;
    color: #606060;
}

img {
    width: 100%;
    height: auto;
}
/* Common end */

/* banner */

.banner img{
    border-radius: 0;
}

.banner {
    position: relative;
}

.banner_title {
    position: absolute;
    top: 45%;
    left: 10%;
    transform: translate(-10%, -45%);
}

.banner_title h1 {
    font-size: 60px;
    margin-bottom: 15px;
    color: #be811a;
}

.banner_title span {
    color: #26332d;
}

.banner_title p {
    font-size: 24px;
    color: #26332d;
    letter-spacing: 1.2px;
}

.banner_title p span {
    font-weight: 600;
}

/* banner end */

.img_box {
    text-align: center;
}

.small_title {
    color: #606060;
    font-size: 16px;
    margin-top: 60px;
}

.text_box span {
    color: #668b84;
}

.conflict_box .text_mod {
    text-align: start;
}

.table-container {
    overflow-x: auto;
    border-radius: 4px
}

table {
    width: 100%;
    border-collapse: collapse;
}

th,
td {
    border: 1px solid #eaeaea;
    padding: 10px 30px 12px;
    text-align: center;
    color: #212529;
    min-width: 320px;
}

th {
    font-size: 16px;
}

.table_info {
    margin: 20px 0 20px 0;
}

.table_info h4 {
    text-align: center;
    font-size: 32px;
}

.text_alt {
    text-align: start;
}

.text_alt h4 {
    font-size: 28px;
    margin-bottom: 10px;
}

.end_button {
    background-color: #405955;
    padding: 15px;
    text-align: center;
}

.end_button span {
    font-size: 16px;
    font-style: italic;
    color: #ffffff;
}
.text_display_mod {
    display: none;
}
@media(max-width: 1150px) {
    .banner_title h1 {
        font-size: 42px;
        margin-bottom: 15px;
        /* color: #be811a; */
    }

    .banner_title{
        position: absolute;
       
    }
    .text_display_mod {
        display: none;
    }
}

@media(max-width: 992px) {
    .text_display_mod {
        display: block;
    }
  .text_display{
    display: none;
  }
  
    .banner_title h1 {
        font-size: 32px;
        margin-bottom: 15px;
        /* color: #be811a; */
    }
    .banner_title p {
        font-size: 18px;
    }

    .table-container {
        overflow-x: scroll;
    }
    

}

@media(max-width: 767px) {
  

    .banner_title {
        position: static;
        transform: none;
        text-align: center;
        padding-top: 10px;
    }

    .banner_title h1 {
        font-size: 24px;
        margin-bottom: 10px;
        margin-top: 15px;
    }
    .banner_title p {
        font-size: 12px;
        color: #405955;
    }
    .banner_title span{
        color: #405955;
    }


    .small_title {
        font-size: 14px;
        margin-top: 30px;
    }
    /* h4{
        font-size: 24px;
    } */
    p{
        font-size: 14px;
    }
    .table_info{
        text-align: center;
    }
    th, td {
        padding: 10px 20px 12px;
        min-width: 220px;
        font-size: 14px;
    }
    .text_box{
        margin-bottom: 30px;
    }
    .conflict_box .text_mod {
        text-align: center;
    }
    .ethical_block {
        margin: 30px 0;
    }
    .small_title{
        margin-top: 30px;
    }
    .table_info h4 {
        text-align: center;
        font-size: 24px;
    }
    .text_alt h4 {
        font-size: 24px;
    }
    .table-container {
        overflow-x: scroll;
    }
    .flip {
        flex-direction: column-reverse;
    }
    .end_button span{
        font-size: 14px;
    }
    .row, .col-12, .col-md-6, .col-lg-6, .text_alt {
        text-align: center !important;
    }
    .zoom-active .img_alt,
    .zoom-active .text_alt {
        animation: none !important;
    }


}

/* --------animation---------- */
.img_box_mod{
    overflow: hidden;
    max-width: 100%;
    max-height: 100%;

}
.img_box_mod img{

    transition: 0.8s; 
    /* image-rendering: pixelated; */
}
.img_box_mod img:hover{

    transform: scale(1.2);
    transition: 0.8s;  
}

/* --------animation---------- 


@keyframes slideInRight {
    0% {
        transform: translateX(-10%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes slideInLeft {
    0% {
        transform: translateX(15%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes slideImageInRight {
    0% {
        transform: translateX(10%) scale(1.05);
        opacity: 0;
    }

    100% {
        transform: translateX(0) scale(1);
        opacity: 1;
    }
}

@keyframes slideImageInLeft {
    0% {
        transform: translateX(-10%) scale(1.05);
        opacity: 0;
    }

    100% {
        transform: translateX(0) scale(1);
        opacity: 1;
    }
}

.zoom-active .img_alt {
    animation: zoomInOut 1s ease-in-out, slideImageInRight 1s ease-in-out;
}

.zoom-active .text_alt {
    animation: slideInLeft 1s ease-in-out;
}

.flip.zoom-active .img_alt {
    animation: zoomInOut 1s ease-in-out, slideImageInLeft 1s ease-in-out;
}

.flip.zoom-active .text_alt {
    animation: slideInRight 0.8s ease-in-out;
}
*/
</style>
